import { useEffect, useMemo } from 'react';
import { usePurchaseInvalidation } from '../../../../hooks/purchases/invalidation/usePurchaseInvalidation';
import { useInvalidationType } from '../../../../hooks/invalidationType/useInvalidationType';
import SelectField from '../../../Forms/Input/SelectField';
import InputField from '../../../Forms/Input/InputField';
import { DOCUMENT_TYPE_CODES } from '../../../../constants/documentTypeCodes';

const PurchaseCancelForm = () => {
  const { form, formErrors, updateField, onChangeInvalidationType } = usePurchaseInvalidation();
  const { invalidationTypeDropdown, fetchInvalidationTypeDropdown } = useInvalidationType();

  useEffect(() => {
    fetchInvalidationTypeDropdown();
  }, []);

  const hasDocumentType = !!form.documentTypeCode; // ¿ya hay prefill?
  const isExcludedSubject = form.documentTypeCode === DOCUMENT_TYPE_CODES.EXCLUDED_SUBJECT;

  // Motivos permitidos
  const allowedCodes = !hasDocumentType
    ? ['1', '2', '3']
    : isExcludedSubject
    ? ['1', '2', '3']
    : ['2'];

  const filteredInvalidationTypes = useMemo(
    () =>
      (invalidationTypeDropdown || []).filter((item) =>
        allowedCodes.includes(String(item.code))
      ),
    [invalidationTypeDropdown, allowedCodes]
  );

  // Si HAY tipo de documento y la opción seleccionada deja de ser válida, limpiarla
  useEffect(() => {
    if (
      hasDocumentType &&
      form.invalidationTypeCode != null &&
      !allowedCodes.includes(String(form.invalidationTypeCode))
    ) {
      updateField('invalidationTypeCode', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDocumentType, allowedCodes, form.invalidationTypeCode]);

  // Si HAY tipo y NO es Sujeto Excluido, limpiar el código de generación
  useEffect(() => {
    if (hasDocumentType && !isExcludedSubject && form.generationCodeToInvalidate) {
      updateField('generationCodeToInvalidate', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDocumentType, isExcludedSubject]);

  // ✅ Mostrar campo si NO hay tipo de documento (sin prefill) o si es Sujeto Excluido
  const showGenerationField = !hasDocumentType || isExcludedSubject;

  return (
    <div className="w-full space-y-6">
      <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2">
        <SelectField
          label="Motivo de Anulación"
          name="invalidationTypeCode"
          iconKey="list"
          value={(form.invalidationTypeCode ?? '').toString()}
          onChange={(e) => onChangeInvalidationType(e.target.value)}
          options={filteredInvalidationTypes.map((item) => ({
            value: String(item.code),
            label: item.name,
          }))}
          placeholder="Seleccione el motivo"
          error={formErrors.invalidationTypeCode}
          required
        />

        {showGenerationField && (
          <div className="sm:col-span-2">
            <InputField
              label="Código de Generación"
              name="generationCodeToInvalidate"
              value={form.generationCodeToInvalidate ?? ''}
              onChange={(e) =>
                updateField('generationCodeToInvalidate', e.target.value)
              }
              iconKey="hash"
              error={formErrors['generationCodeToInvalidate']}
              type="text"
              required={isExcludedSubject} 
              placeholder="664F9D1B-70DA-427D-93B5-C3C7C4B4B9C7"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseCancelForm;
